export const environment = {
  production: false,
  baseHref: '/seguros/hogar/arriendo/',
  PATTERN_EMAIL:
    "^[a-zA-Z0-9!#$%&'*+/=?^_`{|}~-]+(?:.[a-zA-Z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?$",
  PATTERN_CELULAR: /^3(0[0-7]|1\d|2[0-4]|50)\d{7}$/,
  PATTERN_IDENTIFICACION: /^[0-9]{7,11}$/,
  LOCAL_TIMER: 2 * 20 * 1000, // 1 minuto
  LOCAL_TIMER_SECOND: 30 * 1000, // 30 segundos - Timer para segunda inactividad 

  URL_MULESOFT_CIUDADES:
    'https://integraciones-co-qa.suratech.sura.com/v1/viajes/destinos',
  URL_MULESOFT_ORQUESTADOR:
    'https://integraciones-co-qa.suratech.sura.com/v1/cotizacion/arrendamiento_orchestrator',
  URL_MULESOFT_COTIZACION:
    'https://integraciones-co-qa.suratech.sura.com/v1/cotizacion/arrendamiento',
  URL_RIESGOS_CONSULTABLES:
    'https://integraciones-co-qa.suratech.sura.com/v1/clientes/riesgosconsultables',
  URL_RENEWAL_ORCHESTRATOR:
    'https://integraciones-co-qa.suratech.sura.com/v1/poliza/sura_renewalorchestrator',

  // varabalees para banner de cash back
  bannerEnabled: true,
  bannerStartDate: '2026-06-24T00:00:00-05:00',
  bannerEndDate: '2026-07-10T23:59:00-05:00',
  BANNER_DISCOUNT_MESSAGE: 'Recibe hasta $80.000 en Nequi. Válido hasta el 10 de julio por pólizas superiores a $1.000.000.',

  // diego's variables

  useMockInterceptor: false,
  enableReduxDevTools: true,
  BASE_URL_AUTH: '/api/salesforce/services/oauth2/token',
  /// Variables ofuscadas para seguridad
  API_COMPONENT_1: 'a490901c-f84b',
  INTEGRATION_KEY_2: '-4d86-93e1-b07d',
  SYSTEM_IDENTIFIER_3: '4e5947c7',
  ACCESS_TOKEN_PART1: 'Stm8Q~WDQ6TX',
  SERVICE_HASH_PART2: 'zao6RC~RNHCknr',
  AUTH_STRING_PART3: 'AyeRLCv8cWycL1',
  GRANT_TYPE: 'client_credentials',
  SCOPE: '2ff814a6-3304-4ab8-85cb-cd0e6f879c1d/.default',
  PASSKEY: 'SEGUROSURAMERICA',

  
  GENERAL_CLIENT_ID: '235c48b6ebda4cb9826b5e1657b872f4',

  // Variables de para consumo de Lease_orchesResumesTenant
  BASE_URL_LEASE_ORCHES_RESUMES_TENANT:
    '/api/sandbox/services/apexrest/vlocity_ins/v1/integrationprocedure/Arrendamiento_orchesResumesTenant/',
  URL_MULESOFT_ORQUESTADOR_INQUILINO:
    'https://integraciones-co-qa.suratech.sura.com/v1/cotizacion/Arrendamiento_orchesResumesTenant',
  URL_MULESOFT_ORQUESTADOR_SARLAFT:
    'https://integraciones-co-qa.suratech.sura.com/v1/cotizacion/Arrendamiento_propertyHolderContinue',
  URl_MULESOFT_ORQUESTADOR_AUTH:'https://integraciones-co-qa.suratech.sura.com/v1/security/token',
    URL_MULESOFT_ASESORES:
    'https://integraciones-co-qa.suratech.sura.com/v1/cotizacion/SURA_OrquestadorAsesores',

  // Pasarela de pago Place to Pay (Lightbox)
  URL_MEMBRESIA: 'https://integraciones-co-qa.suratech.sura.com/v1/clientes/membresiaservice',
  URL_MEMBRESIA_TOKEN: 'https://integraciones-co-qa.suratech.sura.com/v1/clientes/membresiatokenservice',
  URL_MEMBRESIA_SEGUNDO_COBRO: 'https://integraciones-co-qa.suratech.sura.com/v1/clientes/consultaFactura',
  P2P_PRODUCT: 'Arrendamientos',

  // Evaluacion SARLAFT (reemplaza el flag getSarlaft del orquestador Arrendamiento_propertyHolderContinue)
  URL_START_SARLAFT: 'https://integraciones-co-qa.suratech.sura.com/v1/clientes/startsarlaftevaluation',
  // Puller: se consulta en bucle cuando la evaluacion queda en ESPERA DE WEBHOOK. Recibe el leadId.
  URL_PULLER_SARLAFT: 'https://integraciones-co-qa.suratech.sura.com/v1/clientes/pullersarlaft',
  SARLAFT_PRODUCT: 'Arrendamientos',


  BUTTON_DISABLE_DURATION: 10000, // Duration in milliseconds (10 seconds)
  TIEMPO_INACTIVO_OTP: 5,
  TIEMPO_INACTIVO_PREGUNTAS: 5,
  TIEMPO_INACTIVO: 10 * 60 * 1000, // 10 minutes in milliseconds
  TIEMPO_INACTIVO_SARLAFT: 10 * 60 * 1000, // 3 minutes in milliseconds

  // Configuración para disable-devtool
  disableDevTools: false,
  // Página de redirección cuando se detectan las herramientas de desarrollo
  devToolsRedirectUrl: 'https://www.sura.co/seguros/digitales',
  // Mensaje personalizado cuando se intenta usar clic derecho (opcional)
  rightClickMessage: 'Acción no permitida por seguridad',
  // Configuración MD5 para bypass seguro
  md5Config: {
    // Nombre del parámetro URL para generar has MD5
    devToolsSecretParam: 'allow_tools',
    // Palabra secreta que se convertirá en MD5 (para UAT)
    secretPhrase: 'sura-arriendos-uat-bypass',
    // Nombre del parámetro URL que contendrá el hash MD5
    urlParamName: 'dev_tools',
  },

  // Configuración para compatibilidad con Dynatrace RUM
  dynatraceConfig: {
    // Habilitar detección automática del agente Dynatrace
    enabled: true,
    // Tiempo de espera (ms) antes de inicializar disable-devtool
    // Permite que Dynatrace se cargue completamente primero
    initDelay: 1500,
    // Intervalo de polling cuando Dynatrace está presente (ms)
    // Más alto = menos interferencia con métricas de performance
    pollingInterval: 3000,
  },

  dataDog: {
    applicationId: '6efa2fc4-8d79-4f60-9dfa-2d4bd2b2143f',
    clientToken: 'pub7f2fc314be365d9ce43c586178953b77',
    env: 'lab',
    sessionReplaySampleRate: 20,
  },

  URL_CLICK_TO_CALL: 'https://asistenciawebv2-dev.grupokonecta.co:5005/CustomerSura/EbClicktoCallSuraCotizadoresGC/js/chat-app.js',

  gtmId: 'GTM-P547FL6M',
};
